/* eslint-disable jsx-a11y/anchor-is-valid */
import { useTranslator } from '@front-activerse/common-components';

const ExternalProviderPlaceholder = ({
  displayAppleButton,
  displayFacebookButton,
  displayGoogleButton,
  socialBtnClassName = '',
}) => {
  const { t } = useTranslator();

  return (
    <>
      {displayFacebookButton && (
        <div className="placeholder-glow ">
          <a
            href=""
            className={`btn d-block btn-social facebook placeholder mb-m ${socialBtnClassName}`}
          >
            {t('continueWithFacebook.button')}
          </a>
        </div>
      )}

      {displayAppleButton && (
        <div className="placeholder-glow">
          <a
            href=""
            className={`btn d-block btn-social apple placeholder mb-m ${socialBtnClassName}`}
          >
            {t('continueWithApple.button')}
          </a>
        </div>
      )}

      {displayGoogleButton && (
        <div className="placeholder-glow">
          <a href="" className={`btn d-block btn-social google placeholder ${socialBtnClassName}`}>
            {t('continueWithGoogle.button')}
          </a>
        </div>
      )}
    </>
  );
};

export default ExternalProviderPlaceholder;
